let API_SERVER_HOST = '';
let URL_API_BASE = '';
let FILE_URL_PREFIX = '';
let FILE_URL_DOWNLOAD = '/governApi/files/downloadFile/';
let QUERY_FILE_JSON = '/governApi/files/queryFileJson';

if (process.env.NODE_ENV === 'development') {
    API_SERVER_HOST = location.host
    URL_API_BASE = location.protocol + '//' + API_SERVER_HOST
    // FILE_URL_PREFIX = URL_API_BASE + "/file/downloadbyfastdfspath?fastdfspath="
    FILE_URL_PREFIX = URL_API_BASE + "/governApi/files/previewFile/"
} else if (process.env.NODE_ENV === 'production') {
    // 服务API地址
    // API_SERVER_HOST = '10.3.11.10:8010'
    // API_SERVER_HOST = 'http://stat.las.ac.cn:8010'
    API_SERVER_HOST = location.host
    URL_API_BASE = location.protocol + '//' + API_SERVER_HOST
    // FILE_URL_PREFIX = URL_API_BASE + "/file/downloadbyfastdfspath?fastdfspath="
    FILE_URL_PREFIX = URL_API_BASE + "/governApi/files/previewFile/"
}
//配置ES下拉框选项
let ES_CONFIG_LIST = ['10.3.11.6', '10.3.11.50', '10.3.11.55'];

export {
    API_SERVER_HOST,
    URL_API_BASE,
    FILE_URL_PREFIX,
    FILE_URL_DOWNLOAD,
    QUERY_FILE_JSON,
    ES_CONFIG_LIST
}


export const HEADER_ACTIVE = {
    INDEX: 'INDEX',
    DATA_SELECT: 'DATA_SELECT',
    DATA_MANAGER: 'DATA_MANAGER',
    DATA_WORK: 'DATA_WORK',
    DATA_USE: 'DATA_USE',
    DATA_MALL: 'DATA_MALL',
    MY_DATA: 'MY_DATA',
    USER_MANAGER: 'USER_MANAGER',
    MY_INFORMATION: 'MY_INFORMATION',
    ABOUT_PLATFORM:'ABOUT_PLATFORM',
}

export const MENU_ACTIVE = {
    Data_Manage: 'Data_Manage',
    Data_Verify: 'Data_Verify',
    Task_Claim: 'Task_Claim',
    Task_Distribute: 'Task_Distribute',
    Information_Resources_Export: 'Information_Resources_Export',
    Information_Resources_Import: 'Information_Resources_Import',
    DATA_Registration: 'DATA_Registration',
    ZHISHI_BIAOQIAN: 'ZHISHI_BIAOQIAN',
    DATA_MODELING_DESIGN: 'DATA_MODELING_DESIGN',
    DATA_MODELING: 'DATA_MODELING',
    DATA_IMPORT: 'DATA_IMPORT',
    DATA_IMPORT_LIST: 'DATA_IMPORT_LIST',
    DATA_STAT: 'DATA_STAT',
    DATA_MAINTAIN: 'DATA_MAINTAIN',
    DATA_CALCULATE: 'DATA_CALCULATE',
    PROCESSOMG_TASK: 'PROCESSOMG_TASK',
    PROCESSOMG_DATA: 'PROCESSOMG_DATA',
    DATA_INDEX: 'DATA_INDEX',
    Data_View_Resource: 'Data_View_Resource',
    Data_View_Model: 'Data_View_Model',
    Data_View_Algorithm: 'Data_View_Algorithm',
    My_Data_Resource: 'My_Data_Resource',
    My_Data_Model: 'MyDataModel',
    My_Data_Task: 'MyDataTask',
    MyProcessTask: 'MyProcessTask',
    My_Data_Algorithm: 'MyDataAlgorithm',
    User_Power: 'User_Power',
    User_Powers: 'User_Powers',
    User_Audit: 'User_Audit',
    User_Stat: 'User_Stat',
    DATA_GET: "DATA_GET",
    ONLINE_ANALYSE: "ONLINE_ANALYSE",
    INTELLIGENCE_ANALYSE: "INTELLIGENCE_ANALYSE",
    MY_INFORMATION: 'MY_INFORMATION',
    Change_Password: 'Change_Password',
    data_content:"data_content",
    data_statistics:"data_statistics",
    data_product:'data_product',
    Data_Administrations:'data_administrations',
    Assets_Audit:"Assets_Audit",
    My_interaction:"My_interaction",
    My_grouping:"My_grouping",  //我的分组
    Permission_Management:"permissionManagement"
}

export const CACHE_KEY = {
    USER_INFO: 'user_info',
    USER: 'login_user',
    TARGET_PATH: 'targetPath'
}